module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00091-fs8.fe609ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00091-fs8.png
// module id = 244
// module chunks = 0